import React from 'react';
import { useLocation } from 'react-router-dom';
import distributorIconImg from 'assets/images/distributor-icon.png';
import grayDistributorIconImg from 'assets/images/gray-distributor-icon.png';

const DISTRIBUTOR_BASE_PATH = '/hyperwolf/distributors';

export default function DistributorIcon(props) {
  const { color, ...rest } = props || {};
  const location = useLocation();
  const pathname = location?.pathname || '';

  // Active when current route is distributor list, add, or edit (matches sidebar active state)
  const isActive =
    color === 'primary' ||
    pathname === DISTRIBUTOR_BASE_PATH ||
    pathname.startsWith(`${DISTRIBUTOR_BASE_PATH}/`);

  const src = isActive ? distributorIconImg : grayDistributorIconImg;

  return (
    <img
      src={src}
      alt="Distributor"
      width={24}
      height={24}
      style={{ display: 'block', objectFit: 'contain' }}
      {...rest}
    />
  );
}
